import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { STORAGE_KEYS as o } from "./storage-manager.js";
import u from "./subscription-manager.js";
import Ft from "../models/server-config.js";
import s from "../common/event-logger.js";
import r from "../../shared-lib/braze-shared-lib.js";

var Ct = /*#__PURE__*/function () {
  function Ct(t) {
    _classCallCheck(this, Ct);

    this.h = t, this.tl = new u(), this.sl = new u(), this.il = new u(), this.rl = null;
  }

  _createClass(Ct, [{
    key: "hl",
    value: function hl() {
      if (null == this.rl) {
        var t = this.h.I(o.q.ol);
        this.rl = null != t ? Ft.yn(t) : new Ft();
      }

      return this.rl;
    }
  }, {
    key: "Zs",
    value: function Zs() {
      return this.hl().ul;
    }
  }, {
    key: "al",
    value: function al(t) {
      if (null != t && null != t.config) {
        var e = t.config;

        if (e.time > this.hl().ul) {
          var _t = new Ft(e.time, e.events_blacklist, e.attributes_blacklist, e.purchases_blacklist, e.messaging_session_timeout, e.vapid_public_key, e.content_cards, e.feature_flags);

          var _s = !1;

          null != _t.gl && this.fn() !== _t.gl && (_s = !0);
          var i = !1;
          null != _t.ml.enabled && this.Ys() !== _t.ml.enabled && (i = !0);

          var _r = !1;

          null != _t.cl.enabled && this.fl() !== _t.cl.enabled && (_r = !0), this.rl = _t, this.h.B(o.q.ol, _t.ss()), _s && this.tl.St(), i && this.sl.St(), _r && this.il.St();
        }
      }
    }
  }, {
    key: "dn",
    value: function dn(t) {
      var e = this.tl.ut(t);
      return this.bl && this.tl.removeSubscription(this.bl), this.bl = e, e;
    }
  }, {
    key: "Ms",
    value: function Ms(t) {
      return this.sl.ut(t);
    }
  }, {
    key: "dl",
    value: function dl(t) {
      return this.il.ut(t);
    }
  }, {
    key: "ge",
    value: function ge(t) {
      return -1 !== this.hl().vl.indexOf(t);
    }
  }, {
    key: "hu",
    value: function hu(t) {
      return -1 !== this.hl().wl.indexOf(t);
    }
  }, {
    key: "Dr",
    value: function Dr(t) {
      return -1 !== this.hl().Cl.indexOf(t);
    }
  }, {
    key: "Fl",
    value: function Fl() {
      return this.hl().jl;
    }
  }, {
    key: "fn",
    value: function fn() {
      return this.hl().gl;
    }
  }, {
    key: "Ys",
    value: function Ys() {
      return this.hl().ml.enabled || !1;
    }
  }, {
    key: "fl",
    value: function fl() {
      return this.hl().cl.enabled && null == this.Tl() ? (s.G(r.A.qs, {
        e: "Missing feature flag refresh_rate_limit."
      }), !1) : this.hl().cl.enabled || !1;
    }
  }, {
    key: "Tl",
    value: function Tl() {
      return this.hl().cl.El;
    }
  }]);

  return Ct;
}();

export { Ct as default };